import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { Plus, Trash } from '@xsolla/ui-icons';

import { ExtraInputButton, FieldInput } from '..';
import { MultiInputWrapper } from './style';

type Props = {
  values: string[];
  name: string;
  addInput: () => void;
  deleteInput: (index: number) => void;
  label: ReactNode;
  errorMessage?: string[];
  mainPlaceholder?: ReactNode;
  extraPlaceholder?: ReactNode;
  dataTestId?: string;
  disabledValues?: string[];
};

const MultiInput = ({
  values,
  name,
  mainPlaceholder,
  extraPlaceholder,
  label,
  errorMessage,
  addInput,
  deleteInput,
  dataTestId,
  disabledValues = []
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <MultiInputWrapper>
        <FieldInput
          disabled={disabledValues.includes(values[0]) && values.length === disabledValues?.length}
          label={label}
          errorMessage={errorMessage && (intl.messages[errorMessage[0]] as string)}
          extraRight={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <ExtraInputButton palette="muted" onClick={addInput} data-test-id={`${dataTestId}-add`}>
              <Plus />
            </ExtraInputButton>
          }
          name={`${name}[0]`}
          data-test-id={`${dataTestId}[0]`}
          placeholder={mainPlaceholder as string}
        />
      </MultiInputWrapper>
      {values.map((_: string, index: number) => {
        if (!index) return null;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <MultiInputWrapper key={`${name}[${index}]`}>
            <FieldInput
              extraRight={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <ExtraInputButton
                  disabled={disabledValues.includes(values[index])}
                  palette="muted"
                  type="button" // use this
                  onClick={() => deleteInput(index)}
                  data-test-id={`${dataTestId}-delete`}>
                  <Trash />
                </ExtraInputButton>
              }
              disabled={disabledValues.includes(values[index])}
              name={`${name}[${index}]`}
              data-test-id={`${dataTestId}[${index}]`}
              errorMessage={errorMessage && (intl.messages[errorMessage[index]] as string)}
              placeholder={extraPlaceholder as string}
            />
          </MultiInputWrapper>
        );
      })}
    </>
  );
};

export default MultiInput;
